<template>
<main class="main" id="scroll">
	<!-- <div class="product_banner">
	</div> -->

	<div class="w1200" style="margin-top:50px;"  v-loading="loading">
        <div class="news-title">
           <h1>{{newsDetail.title}}</h1>
            <h4>{{newsDetail.createTime}}</h4>
        </div>
        <div class="new-content">
            <div v-html="newsDetail.content"></div>
			<!-- <img :src="newsDetail.titleImg" title="" alt=""> -->
        </div>
        <div class="news_btn">
            <router-link class="left" v-if='newsDetail.upNewsInfo' :to="{ path: '/newsDetail', query: { id: newsDetail.upNewsInfo.id}}">上一条：{{newsDetail.upNewsInfo.title}}</router-link>
            <router-link class="right" v-if='newsDetail.nextNewsInfo' :to="{ path: '/newsDetail', query: { id: newsDetail.nextNewsInfo.id}}">下一条：{{newsDetail.nextNewsInfo.title}}</router-link>
        </div>
    </div>

	<div class="pageNews w1200">
	    <p>相关推荐</p>
	    <ul class="clear">
	        <ul class="clear">
		        <li class="wow fadeInUp" v-for="item in newsList">
                    <router-link :to="{ path: '/newsDetail', query: { id: item.id}}">
    		            <div class="img"><img :src="item.titleImg" title="" alt=""></div>
    		            <div class="cont">
    		                <div class="time">{{item.createTime}}</div>
    		                <div class="title">{{item.title}}</div>
    		                <div class="summary">{{item.remark}}</div>
    		            </div>
    		        </router-link>
                </li>
		    </ul>
	    </ul>
	</div>
</main>
		
</template>
<script>
export default {
  name: 'newsDetail',
  data () {
    return {
      newsList:[],
      loading:true,
      newsDetail:''
    }
  },
   watch: {
	  '$route' (to, from) { 
		  if(to.query.id != from.query.id){
		  	$('body,html').animate({
       			scrollTop: 0
			}, 1000);
			var that=this;
		    var obj={}
		    obj.id=this.$route.query.id
		    $.ajax({
		        url : '/api/news/queryNewsInfo',
		        type : 'POST',
		        dataType : 'json',
		        data:JSON.stringify(obj),
		        headers:{
		            'Content-Type': 'application/JSON',
		            'apiFlag':"1"
		        },
		        success : function(data) {
		            that.newsDetail=data.data;
		            that.loading=false
		            console.log(this.newsDetail)
		        },
		        error : function(msg) {
		        }
		    });
		  }
	  }
  },
  created(){ 
  	
  	var that=this;
    var obj={}
    obj.id=this.$route.query.id
    $.ajax({
        url : '/api/news/queryNewsInfo',
        type : 'POST',
        dataType : 'json',
        data:JSON.stringify(obj),
        headers:{
            'Content-Type': 'application/JSON',
            'apiFlag':"1"
        },
        success : function(data) {
            that.newsDetail=data.data;
            that.loading=false
            console.log(this.newsDetail)
        },
        error : function(msg) {
        }
    });
    that.getList()
  },
  methods:{
  	getList(){
  		var that=this;
	    var obj={}
	    obj.page=1,
	    obj.limit=3,
	    $.ajax({
	        url : '/api/news/queryNewsList',
	        type : 'POST',
	        dataType : 'json',
	        data:JSON.stringify(obj),
	        headers:{
	            'Content-Type': 'application/JSON',
	            'apiFlag':"1"
	        },
	        success : function(data) {
	            that.newsList=data.data;
	        },
	        error : function(msg) {
	        }
	    });
  	}
  }

}
</script>



// WEBPACK FOOTER //
// src/components/newsDetail.vue